"use client";

import {
  Pagination,
  type PaginationData,
} from "@/components/common/pagination";
import { blogPagePath } from "@repo/utils/lib/seo-pagination";
import { usePathname, useRouter } from "next/navigation";

export type ArticlesPaginationProps = PaginationData;

export function ArticlesPagination({
  page,
  total,
  limit,
}: ArticlesPaginationProps) {
  const router = useRouter();
  const pathname = usePathname();

  function handlePageChange(newPage: number) {
    const searchParams = new URLSearchParams(window.location.search);
    if (newPage === 1) searchParams.delete("page");
    else searchParams.set("page", String(newPage));
    router.push(`${pathname}?${searchParams.toString()}`, { scroll: false });
  }

  return (
    <Pagination
      data={{ page, total, limit }}
      onPageChange={handlePageChange}
      getPageHref={(target) => blogPagePath(pathname, target)}
    />
  );
}
